import React from 'react';
import Layout from './modules/layout/Layout';
import { Box, Paper } from '@mui/material';

import { WithdrawProvider } from './modules/pages/withdrawals/WithdrawContext';
import ApiClientProvider from './clients/ApiClient';

import { withAuthenticator, WithAuthenticatorProps } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

/**
 * Updated App component
 * - Migrated from `aws-amplify-react` to `@aws-amplify/ui-react`
 * - Switched from deprecated Material‑UI v4 APIs to MUI v5 (`@mui/material`)
 * - Replaced `makeStyles` with the `sx` styling prop
 */
function App({ children }: React.PropsWithChildren<WithAuthenticatorProps>) {
	return (
		<Layout>
			<Box
				sx={{
					minHeight: '100vh',
					maxWidth: 850,
					mx: 'auto',
					backgroundColor: '#f3f6f8',
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<Paper elevation={0} sx={{ width: '100%' }}>
					<Box p={4}>
						<WithdrawProvider>
							<ApiClientProvider>{children}</ApiClientProvider>
						</WithdrawProvider>
					</Box>
				</Paper>
			</Box>
		</Layout>
	);
}

export default withAuthenticator(App, {
	hideSignUp: true, // replaces legacy signUpConfig.isSignUpDisplayed
});
